var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 22H16C16.5523 22 17 21.5523 17 21V20.618C17 20.2393 17.216 19.8971 17.5375 19.697C18.6619 18.997 20.1776 17.662 21.1214 15.75H2.8786C3.82244 17.662 5.33807 18.997 6.46247 19.697C6.78402 19.8971 6.99999 20.2393 6.99999 20.618V21C6.99999 21.5523 7.44771 22 7.99999 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30432 14.25C2.19369 13.8515 2.10976 13.4343 2.05835 12.9988C1.9936 12.4503 2.4477 12 2.99998 12H21C21.5523 12 22.0064 12.4503 21.9416 12.9988C21.8902 13.4343 21.8063 13.8515 21.6957 14.25H2.30432Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4939 2.56444C22.8056 2.29168 22.8372 1.81786 22.5644 1.50613C22.2917 1.1944 21.8179 1.16282 21.5061 1.43558L16.0039 6.25001H6C5.74007 6.25001 5.49867 6.3846 5.36202 6.60571C5.22536 6.82682 5.21294 7.10293 5.32918 7.33542C6.06909 8.81524 7.58158 9.75001 9.23607 9.75001H11.3534C13.2412 9.75001 15.0649 9.06479 16.4857 7.82162L22.4939 2.56444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoup);
export default __webpack_public_path__ + "static/media/soup.9a566d485ce7e397a293a4eb725f76fe.svg";
export { ForwardRef as ReactComponent };